import { OnPremPortOpeningRequestsTypes } from '../enums/POR/OnPremPortOpeningRequestsTypes';
import { PortOpeningRequestsDirection } from '../enums/POR/PortOpeningRequestsDirection';
import User from '../User';
import OnPremWorkflowInstance from '../OnPremWorkflowInstance';

export default class OnPremPORequestObjectOptimized {
    id: number;
    type: OnPremPortOpeningRequestsTypes;
    direction: PortOpeningRequestsDirection;
    approverUser: User | null;
    onPremWorkflowInstance: OnPremWorkflowInstance;
    appEndorser: User | null;

    constructor(data: any) {
        this.id = data.id;
        this.type = new OnPremPortOpeningRequestsTypes().fromName(data.type?.name);
        this.direction = new PortOpeningRequestsDirection().fromName(data.direction?.name);
        this.approverUser = data.approverUser ? new User(data.approverUser) : null;
        this.onPremWorkflowInstance = new OnPremWorkflowInstance(data.onPremWorkflowInstance);
        this.appEndorser = data.appEndorser ? new User(data.appEndorser) : null;
    }
}